import React from 'react';
import Pro01 from "../../images/services/da/Data-Analytics.webp"
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Agile(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container classNanme="h-100">
                <Row classNanme="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                        <div className="example" data-text="Data Effectively">
                            <h2>Utilize Your Data Effectively For A Better Tomorrow With Our Data Analytics
                                Services</h2>
                        </div>
                        <p>When done systematically, things are generally easier to manage and comprehend. At TekRevol,
                            we religiously follow our indigenously crafted, tried, and tested process to bring you the
                            results you are looking for. Our experienced-focus and data-driven big data analytics
                            services are suited for all organizations looking for insights to scaling their operations –
                            from big to huge! TekRevol’s experience enabling organizations to utilize their data to
                            drive increased revenue and value has given us the confidence to expand and reach
                            organizations worldwide to improve their standings.
                        </p>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className=" agile_title my-auto offset-xl-1">
                        <div className=" content_pointer">
                            <div className=" pointers_item">
                                <div className=" title_count">22+<span>Projects completed</span></div>
                            </div>
                            <div className=" pointers_item">
                                <div className=" title_count">20+<span>Businesses served</span></div>
                            </div>
                            <div className=" pointers_item">
                                <div className=" title_count">07+<span>Industries covered</span></div>
                            </div>
                        </div>
                        <LazyLoadImage
                            src={Pro01}
                            effect=" blur" alt=" Image" className=" img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Agile;